/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_ForbiddenInputs */

const th_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณไม่มีสิทธิ์ดำเนินการนี้`)
};

const en_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You do not have permission to do that.`)
};

const ja_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`この操作を行う権限がありません。`)
};

const zh_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你没有权限这样做。`)
};

const es_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tienes permiso para hacer eso.`)
};

const pt_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você não tem permissão para fazer isso.`)
};

const id_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda tidak diizinkan melakukan itu.`)
};

const fr_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous n’avez pas la permission de faire cela.`)
};

const tl_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wala kang pahintulot para diyan.`)
};

const vi_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn không được phép làm điều đó.`)
};

const ko_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`그럴 권한이 없습니다.`)
};

const de_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dazu hast du keine Berechtigung.`)
};

const ru_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас нет прав на это.`)
};

const tr_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bunu yapma yetkiniz yok.`)
};

const it_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non hai il permesso di farlo.`)
};

const pl_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie masz do tego uprawnień.`)
};

const uk_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У вас немає прав на це.`)
};

const hi_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपको इसकी अनुमति नहीं है।`)
};

const ar_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا تملك صلاحية ذلك.`)
};

const ms_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda tiada kebenaran untuk itu.`)
};

const bn_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এর অনুমতি আপনার নেই।`)
};

const zh_tw2_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你沒有執行此操作的權限。`)
};

const zh_hk2_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你沒有執行此操作的權限。`)
};

const ur_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`آپ کو اس کی اجازت نہیں۔`)
};

const fa_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اجازهٔ این کار را ندارید.`)
};

const sw_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huna ruhusa ya kufanya hivyo.`)
};

const nl_err_forbidden = /** @type {(inputs: Err_ForbiddenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je hebt daar geen rechten voor.`)
};

/**
* | output |
* | --- |
* | "You do not have permission to do that." |
*
* @param {Err_ForbiddenInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const err_forbidden = /** @type {((inputs?: Err_ForbiddenInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_ForbiddenInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_err_forbidden(inputs)
	if (locale === "ja") return ja_err_forbidden(inputs)
	if (locale === "zh") return zh_err_forbidden(inputs)
	if (locale === "es") return es_err_forbidden(inputs)
	if (locale === "pt") return pt_err_forbidden(inputs)
	if (locale === "id") return id_err_forbidden(inputs)
	if (locale === "fr") return fr_err_forbidden(inputs)
	if (locale === "tl") return tl_err_forbidden(inputs)
	if (locale === "vi") return vi_err_forbidden(inputs)
	if (locale === "ko") return ko_err_forbidden(inputs)
	if (locale === "de") return de_err_forbidden(inputs)
	if (locale === "ru") return ru_err_forbidden(inputs)
	if (locale === "tr") return tr_err_forbidden(inputs)
	if (locale === "it") return it_err_forbidden(inputs)
	if (locale === "pl") return pl_err_forbidden(inputs)
	if (locale === "uk") return uk_err_forbidden(inputs)
	if (locale === "hi") return hi_err_forbidden(inputs)
	if (locale === "ar") return ar_err_forbidden(inputs)
	if (locale === "ms") return ms_err_forbidden(inputs)
	if (locale === "bn") return bn_err_forbidden(inputs)
	if (locale === "zh-TW") return zh_tw2_err_forbidden(inputs)
	if (locale === "zh-HK") return zh_hk2_err_forbidden(inputs)
	if (locale === "ur") return ur_err_forbidden(inputs)
	if (locale === "fa") return fa_err_forbidden(inputs)
	if (locale === "sw") return sw_err_forbidden(inputs)
	if (locale === "nl") return nl_err_forbidden(inputs)
	return en_err_forbidden(inputs)
});